module.exports = __webpack_public_path__ + "media/images/icons/map-pointer2-579619833e266c774ec5112380f1b714.svg";